import { render, staticRenderFns } from "./BusinessTrainingsView.vue?vue&type=template&id=dbed8e56"
import script from "./BusinessTrainingsView.vue?vue&type=script&lang=js"
export * from "./BusinessTrainingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports